"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actions = require("settings-ui-sdk/Products/actions");

var _ProductQuery = _interopRequireDefault(require("crm_data/products/ProductQuery"));

var initialState = new _ProductQuery.default();

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.FetchProductActionTypes.SUCCESS:
      return action.payload.props;

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;